// 1st View スライダー
class MKSlider {
  constructor(options) {
    try {
      if (options.wrapper) {
        this.wrapper = options.wrapper;
      } else {
        throw new Error('ラッパー要素を設定してください');
      }
      this.slideClass = options.slideClass ? options.slideClass : 'js-kv-slide';
      this.activeClass = options.activeClass ? options.activeClass : 'slide-active';
      this.prevClass = options.prevClass ? options.prevClass : 'slide-prev';
      this.beforeClass = options.beforeClass ? options.beforeClass : 'slide-before';
      this.waitTime = options.waitTime ? options.waitTime : 1000;
      this.durationTime = options.durationTime ? options.durationTime : 800;
      this.delayTime = options.delayTime ? options.delayTime : 0;
      this.autoplay = options.autoplay && options.autoplay === true ? true : false;
      this.offset = options.offset ? options.offset : 0;
      this.onPrepared = options.onPrepared ? options.onPrepared : null;

      this.init();

    } catch (err) {
      console.error(err);
    }

  }
  initFlg;
  num;
  aIdx = -1;
  nIdx = 1;
  slidingId;
  beforeId;
  init() {
    const self = this;
    self.prepare();
    if (self.slides.length > 0 && self.autoplay) {
      self.start();
    }
  }
  prepare() {
    const self = this;
    self.slides = self.setSlides();
    self.slideNum = self.slides.length;
    self.aIdx = self.getBeforeNum(self.offset);
    self.nIdx = self.getNextNum(self.offset);
    self.slides[self.offset].classList.add("slide_active");
    if (self.onPrepared) {
      self.onPrepared(self);
    }
  }
  setSlides() {
    const self = this;
    const slides = self.wrapper.querySelectorAll(`.${self.slideClass}`);
    return slides;
  }
  start() {
    const self = this;
    setTimeout(function () {
      self.setBefore();
    }, self.delayTime);
  }
  setBefore() {
    const self = this;
    if (self.slidingId) {
      clearTimeout(self.slidingId);
    }
    if (self.aIdx > -1) {
      self.slides[self.aIdx].classList.remove("slide_prev");
    } else {
      self.slides[0].classList.add("slide_active");
    }
    self.aIdx = self.getNextNum(self.aIdx);
    self.slides[self.aIdx].classList.add("slide_prev");
    self.slides[self.nIdx].classList.add("slide_before", "slide_active");

    self.slidingId = setTimeout(function () {
      self.sliding();
    }, self.waitTime);
  }
  getNextNum(idx) {
    const self = this;
    idx += 1;
    if (idx > self.slideNum - 1) {
      idx = 0;
    }
    return idx;
  }
  getBeforeNum(idx) {
    const self = this;
    idx -= 1;
    if (idx < 0) {
      idx = self.slideNum - 1;
    }
    return idx;
  }
  sliding() {
    var self = this;
    self.slides[self.aIdx].classList.remove("slide_active");
    self.slides[self.nIdx].classList.remove("slide_before");

    self.nIdx = self.getNextNum(self.nIdx);
    self.beforeId = setTimeout(function () {
      self.setBefore();
    }, self.durationTime);
  }
}

document.addEventListener('DOMContentLoaded', function (event) {
  document.querySelectorAll('.js-kv-slider').forEach(wrapper => {
    let offset = 0;
    let delayTime = 0;
    if (wrapper.dataset.offsetSlide && !isNaN(Number(wrapper.dataset.offsetSlide))) {
      offset = Number(wrapper.dataset.offsetSlide);
    }
    if (wrapper.dataset.delay && !isNaN(Number(wrapper.dataset.delay))) {
      delayTime = Number(wrapper.dataset.delay);
    }

    const options = {
      waitTime: 3000,
      durationTime: 1800,
      wrapper: wrapper,
      autoplay: true,
      offset: offset,
      delayTime: delayTime,
      onPrepared: function (mkslider) {
        if (mkslider.wrapper.classList.contains('is-wait')) {
          mkslider.wrapper.classList.remove('is-wait')
        }
      }
    }
    new MKSlider(options);

  })
})


// swiper 自動再生
const swiper = new Swiper(".js-swiper", {
  loop: true,
  speed: 5000,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  slidesPerView: 1.5,
  spaceBetween: 10,

  // ブレークポイント（画面幅による設定）
  breakpoints: {
    // 画面幅が 768px 以上の場合（window width >= 768px）
    768: {
      slidesPerView: 2.5,
      spaceBetween: 20
    },
    // 画面幅が 1024px 以上の場合（window width >= 1024px）
    1024: {
      slidesPerView: 3.5,
      spaceBetween: 30
    }
  },
});